// requiredWith:otherFieldName[,anotherFieldName]
// passes while every referenced field is empty; once any of them has a value, this field must have one too
// used for things like validity dates that are only required when a file has been uploaded in the same form
// NOTE: rule names must be camelCase (no underscores) - see js/formulate-config.js
const isEmpty = (value) => value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0);

const requiredWith = ({ value, getFormValues }, ...otherFieldNames) => {
  const formValues = getFormValues() || {};
  const anyOtherHasValue = otherFieldNames.some((fieldName) => !isEmpty(formValues[fieldName]));
  return !anyOtherHasValue || !isEmpty(value);
};

const requiredWithMessage = ({ name }) => `${name} is required once a file has been uploaded.`;

export default {
  rules: { requiredWith },
  messages: {
    requiredWith: requiredWithMessage,
  },
};
